import React from 'react';
import {
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import Layout from '../Layout';
import ProfilePage from './ProfilePage';
import VerifyPhonePage from './VerifyPhonePage';

export default function () {
  return (
    <Layout>
      <Routes>
        <Route path='/' element={<ProfilePage />} />
        <Route path="/confirm-phone"
          element={<VerifyPhonePage/>}
        />
        <Route path='/*' element={<Navigate to="./" replace/>} />
      </Routes>
    </Layout>
  );
};